import React from 'react';

// Shared admin UI primitives matching the Rangeet admin aesthetic (image 1).

export function Panel({
  title,
  icon,
  action,
  children
}: {
  title: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
}) {
  return <section className="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm" data-id="element-584" data-mp="12521duwqw7xn">
      <header className="flex items-center justify-between bg-slate-50 px-5 py-3.5" data-id="element-585" data-mp="173vdbiwdvqvp">
        <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-slate-800" data-id="element-586" data-mp="ahjppz7m46g8">
          {icon}
          {title}
        </h2>
        {action}
      </header>
      <div data-id="element-587" data-mp="jfln84s50gyr">{children}</div>
    </section>;
}
export function AddButton({
  onClick,
  label = 'Add'
}: {
  onClick?: () => void;
  label?: string;
}) {
  return <button onClick={onClick} aria-label={label} className="flex h-8 w-8 items-center justify-center rounded-full bg-[#1e2a5a] text-lg font-bold text-white transition hover:bg-[#2a3a70]" data-id="element-588" data-mp="3mx3tw8w6bhxl">
      +
    </button>;
}
export function StatusToggle({
  on,
  onToggle
}: {
  on: boolean;
  onToggle: () => void;
}) {
  return <button role="switch" aria-checked={on} onClick={onToggle} className={`relative h-6 w-11 rounded-full transition ${on ? 'bg-[#1e2a5a]' : 'bg-slate-300'}`} data-id="element-589" data-mp="zw1yu4lggnjn">
      <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition ${on ? 'left-[22px]' : 'left-0.5'}`} data-id="element-590" data-mp="q4ftgovstiot" />
    </button>;
}
export function RowButton({
  variant,
  children,
  onClick
}: {
  variant: 'read' | 'edit' | 'danger';
  children: React.ReactNode;
  onClick?: () => void;
}) {
  const styles = {
    read: 'bg-[#2f6fce] hover:bg-[#2a63b8]',
    edit: 'bg-[#f0932b] hover:bg-[#e08420]',
    danger: 'bg-[#d63447] hover:bg-[#bf2c3e]'
  }[variant];
  return <button onClick={onClick} className={`rounded px-3 py-1.5 text-xs font-semibold text-white transition ${styles}`} data-id="element-591" data-mp="26h4lbnu61ef5">
      {children}
    </button>;
}
export function PageHeading({
  title,
  subtitle
}: {
  title: string;
  subtitle: string;
}) {
  return <div className="mb-5" data-id="element-592" data-mp="2ph0oefdwacfk">
      <h1 className="font-heading text-xl font-bold text-slate-900" data-id="element-593" data-mp="2phajghdsr9s4">{title}</h1>
      <p className="text-sm text-slate-500" data-id="element-594" data-mp="2bpvwjzgrqofs">{subtitle}</p>
    </div>;
}